import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureContentWorksheet/derivedFromMeasurementsConfig';
import qestIds from '../../../QestIds';
import getMeasuredUsingConfig from '../../measuredUsingConfig';
import getLabelConfig from './labelConfig';

/**
 * Additional arguments to customise the returned config object
 * of an AASHTO moisture content test
 */
export type AashtoMoistureContentGetConfigFunctionArgs = {
  /**
   * Overrides the term "Material" in field labels
   */
  materialLabelOverride?: string;

  /**
   * Defines a set of fields to set property `disabled` to true (by unprefixed field name)
   */
  disabledPaths?: string[];
};

const getConfig = (
  prefix: string,
  { materialLabelOverride = undefined, disabledPaths = [] }: AashtoMoistureContentGetConfigFunctionArgs = {}
) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.VisualNominalParticleSize`]: {
        disabled: disabledPaths.some((s) => s === 'Preparation.VisualNominalParticleSize'),
      },
      [`${prefix}.Equipment.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: { uom: 'h', format: { nearest: 0.01 } },
      ...getMoistureContentPercent(`${prefix}.Results.MoistureContentPercent`),
    },
    getLabelConfig(prefix, materialLabelOverride),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Equipment.DryMassBalance`]: { defaultReadability: 0.1, defaultUom: 'g' },
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 0.1, defaultUom: 'g' },
    }
  );

/**
 * TODO: Used by other tests (Atterberg Limits, MDD) to round determined Moisture Content the same way
 * When labels are migrated for those test-types, remove the label from this config
 */
const getMoistureContentPercent = (name: string) => ({
  [`${name}`]: { format: { nearest: 0.1 }, label: 'Moisture Content (%)' },
});

export { getConfig, getMoistureContentPercent };

export default {
  [qestIds.moistureContent.AASHTO_T_265.rev2015]: getConfig,
};
